<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0">
        <div class="card-body p-3">
          <!-- Header Section -->
          <div class="d-flex flex-row flex-wrap justify-content-between align-items-center mb-4">
            <div class="d-flex align-items-center">
              <button class="btn btn-icon me-3 border" routerLink="/dealers">
                <i class="bi bi-arrow-left"></i>
              </button>
              <div>
                <h1 class="card-title mb-1">Dealer Insights</h1>
                <span class="sub-text text-muted">
                  Overview of orders and payments for {{ insights?.orders_history?.[0]?.dealer?.shop_name || 'Dealer' }}
                </span>
              </div>
            </div>

            <div class="d-flex align-items-center gap-2">
              <button
                class="btn btn-soft-primary d-flex align-items-center gap-2"
                (click)="onExportOrders()"
                [disabled]="isExportingOrders">
                @if (isExportingOrders) {
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Exporting...
                } @else {
                  <i class="bi bi-download"></i>
                  Export Dealer Orders
                }
              </button>
              <button
                class="btn btn-soft-primary d-flex align-items-center gap-2"
                (click)="onExportPayments()"
                [disabled]="isExportingPayments">
                @if (isExportingPayments) {
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Exporting...
                } @else {
                  <i class="bi bi-download"></i>
                  Export Dealer Payments
                }
              </button>
            </div>
          </div>

          @if (isDataLoading) {
            <app-loading-spinner></app-loading-spinner>
          } @else {
            <!-- Summary Cards -->
            <div class="row g-3 mb-4">
              <div class="col-md-4">
                <div class="insight-card bg-white border">
                  <div class="insight-card-body">
                    <div class="insight-icon bg-primary-light text-primary">
                      <i class="bi bi-box-seam"></i>
                    </div>
                    <div class="insight-content">
                      <span class="insight-label">Total Orders</span>
                      <h3 class="insight-value">{{ insights?.summary?.total_orders || 0 }}</h3>
                    </div>
                  </div>
                  <div class="insight-footer bg-light px-3 py-2 border-top">
                    <span class="small text-muted">Successful orders processed</span>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="insight-card bg-white border">
                  <div class="insight-card-body">
                    <div class="insight-icon bg-success-light text-success">
                      <i class="bi bi-credit-card"></i>
                    </div>
                    <div class="insight-content">
                      <span class="insight-label">Total Payments</span>
                      <h3 class="insight-value">{{ insights?.summary?.total_payments || 0 }}</h3>
                    </div>
                  </div>
                  <div class="insight-footer bg-light px-3 py-2 border-top">
                    <span class="small text-muted">Transaction history count</span>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="insight-card bg-white border">
                  <div class="insight-card-body">
                    <div class="insight-icon bg-info-light text-info-emphasis">
                      <i class="bi bi-currency-rupee"></i>
                    </div>
                    <div class="insight-content">
                      <span class="insight-label">Amount Paid</span>
                      <h3 class="insight-value">
                        ₹{{ insights?.summary?.total_payment_amount || 0 | number: '1.2-2' }}
                      </h3>
                    </div>
                  </div>
                  <div class="insight-footer bg-light px-3 py-2 border-top">
                    <span class="small text-muted">Total collections from dealer</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Content Tabs/Sections -->
            <div class="card border-0 shadow-none">
              <div class="card-body p-0 mt-2">
                <app-tab-navigation [tabs]="tabs" [selectedTab]="selectedTab" (tabChange)="selectTab($event)" />

                <div class="tab-content mt-3" id="dealerTabsContent">
                  <ng-container [ngSwitch]="selectedTab">
                    <!-- Orders History Content -->
                    <div *ngSwitchCase="'orders'" class="tab-pane fade show active">
                      <div class="table-responsive">
                        <table class="table table-history align-middle">
                          <thead>
                            <tr>
                              <th class="ps-4">Order ID</th>
                              <th>Date</th>
                              <th>Total Boxes</th>
                              <th>Invoice Status</th>
                              <th class="text-center">Status</th>
                              <th class="pe-4 text-end">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (order of insights?.orders_history; track order.id) {
                              <tr>
                                <td class="ps-4 fw-bold text-primary">{{ order.order_number }}</td>
                                <td class="text-muted small">{{ order.created_at | date: 'mediumDate' }}</td>
                                <td>
                                  <span class="badge bg-light text-dark border">{{ order.total_boxes_ordered }}</span>
                                </td>
                                <td>
                                  <span class="text-uppercase small text-muted">{{ order.invoice_status }}</span>
                                </td>
                                <td class="text-center">
                                  <span
                                    class="app-badge text-white {{
                                      order.is_order_cancelled
                                        ? 'bg-danger'
                                        : order.is_fully_delivered
                                          ? 'bg-success'
                                          : 'bg-primary'
                                    }}">
                                    {{
                                      order.is_order_cancelled
                                        ? 'Cancelled'
                                        : order.is_fully_delivered
                                          ? 'Delivered'
                                          : 'In Progress'
                                    }}
                                  </span>
                                </td>
                                <td class="pe-4 text-end">
                                  <button class="btn btn-sm btn-action-info" [routerLink]="['/orders', order.id]">
                                    <i class="bi bi-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            } @empty {
                              <tr>
                                <td colspan="6" class="text-center py-5">
                                  <div class="text-muted">
                                    <i class="bi bi-inbox fs-1 d-block mb-3"></i>
                                    No orders found for this dealer.
                                  </div>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Payments History Content -->
                    <div *ngSwitchCase="'payments'" class="tab-pane fade show active">
                      <div class="table-responsive">
                        <table class="table table-history align-middle">
                          <thead>
                            <tr>
                              <th class="ps-4">Date</th>
                              <th>Reference No.</th>
                              <th>Mode</th>
                              <th>Amount</th>
                              <th class="pe-4 text-end">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (payment of insights?.payments_history; track payment.id) {
                              <tr>
                                <td class="ps-4 text-muted small">{{ payment.date | date: 'mediumDate' }}</td>
                                <td class="text-muted small">{{ payment.reference_number || '-' }}</td>
                                <td>
                                  <span class="badge bg-light text-dark border text-uppercase">
                                    {{ payment.payment_type || '-' }}
                                  </span>
                                </td>
                                <td class="fw-bold text-success">₹{{ payment.received_amount | number: '1.2-2' }}</td>
                                <td class="pe-4 text-end">
                                  <button
                                    class="btn btn-sm btn-action-info"
                                    title="View Proof"
                                    [disabled]="!payment.proof"
                                    (click)="viewProof(payment.proof)">
                                    <i class="bi bi-file-earmark-image"></i>
                                  </button>
                                </td>
                              </tr>
                            } @empty {
                              <tr>
                                <td colspan="5" class="text-center py-5">
                                  <div class="text-muted">
                                    <i class="bi bi-credit-card-off fs-1 d-block mb-3"></i>
                                    No payments history found for this dealer.
                                  </div>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
